import { all } from 'redux-saga/effects';
import { meetingsSaga } from './sagas/eventsSaga';
import { sessionSaga } from './sagas/sessionSaga';
import { onboardingSaga } from './sagas/oboardingSaga';
import { organizationsSaga } from './sagas/organizationsSaga';

export default function* rootSaga() {
  yield all([meetingsSaga(), sessionSaga(), onboardingSaga(), organizationsSaga()]);
}
